import { types, actions } from './requests'
export const GETCORPLIST_TYPES = {
    ...types('GETCORPLIST'),
}
export const GETCORPLIST_ACTIONS = {
    ...actions('GETCORPLIST'),
}
